import { useEffect, useState } from "react";
import { Download, Share, X, MoreVertical } from "lucide-react";
import { useT } from "@/lib/i18n";

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const ua = () => navigator.userAgent;
const isIOS = () => /iphone|ipad|ipod/i.test(ua()) && !window.MSStream;
const isSafariMac = () => /safari/i.test(ua()) && !/chrome|chromium|crios|edg/i.test(ua()) && !isIOS();
const isFirefox = () => /firefox/i.test(ua());

let deferredGlobal = null;
if (typeof window !== "undefined") window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredGlobal = e; window.dispatchEvent(new Event("pwa-prompt-ready")); });

export function InstallPrompt({ force = false }) {
  const { t } = useT();
  const [deferred, setDeferred] = useState(deferredGlobal);
  const [installed, setInstalled] = useState(standalone());
  const [dismissed, setDismissed] = useState(localStorage.getItem("mo_install_dismissed") === "1");
  useEffect(() => {
    const onReady = () => setDeferred(deferredGlobal);
    const onInstalled = () => setInstalled(true);
    window.addEventListener("pwa-prompt-ready", onReady); window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("pwa-prompt-ready", onReady); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  if (installed || (dismissed && !force)) return null;
  const dismiss = () => { setDismissed(true); localStorage.setItem("mo_install_dismissed", "1"); };
  const install = async () => { if (!deferred) return; deferred.prompt(); const { outcome } = await deferred.userChoice; if (outcome === "accepted") setInstalled(true); deferredGlobal = null; setDeferred(null); };
  const manual = isIOS() ? t("install_ios_steps") : isSafariMac() ? t("install_safari_steps") : isFirefox() ? t("install_firefox_steps") : t("install_chrome_steps");
  return (
    <div data-testid="install-prompt" className="mb-4 rounded-2xl border border-[#5aa469]/30 bg-[#f6faf6] p-3">
      <div className="flex items-start gap-3">
        <img src="/icons/icon-192.png" alt="" className="h-10 w-10 rounded-xl" />
        <div className="min-w-0 flex-1 text-sm">
          <p className="font-heading font-extrabold">{t("install_title")}</p>
          <p className="text-xs text-slate-600">{t("install_desc")}</p>
          {!deferred && <p data-testid="install-manual-steps" className="mt-1 flex items-center gap-1 text-xs text-slate-500">{isIOS() || isSafariMac() ? <Share size={12} /> : <MoreVertical size={12} />} {manual}</p>}
        </div>
        {!force && <button data-testid="install-dismiss" onClick={dismiss} className="text-slate-400 hover:text-slate-700"><X size={16} /></button>}
      </div>
      {deferred && <button data-testid="install-btn" onClick={install} className="mt-2 flex w-full items-center justify-center gap-2 rounded-xl bg-[#5aa469] py-2 text-sm font-bold text-white sm:w-auto sm:px-5"><Download size={16} />{t("install_btn")}</button>}
    </div>
  );
}
